<template>
  <div class="tools_wrap">
    <!-- 顶部区：子 Tab + 查询条件 + 新增按钮统一收在同一栏 -->
    <div class="page_head">
      <div class="sub_tabs">
        <span :class="{ active: subTab === 'tools' }" @click="subTab = 'tools'">{{ isAdmin ? '平台工具' : '自建工具' }}</span>
        <span :class="{ active: subTab === 'mcp' }" @click="subTab = 'mcp'">{{ isAdmin ? '平台 MCP 服务' : 'MCP 服务' }}</span>
        <span v-if="!isAdmin" :class="{ active: subTab === 'catalog' }" @click="subTab = 'catalog'">平台目录</span>
      </div>

      <!-- 自建工具查询 -->
      <div v-show="subTab === 'tools'" class="head_tools">
        <el-form :inline="true" :model="toolQuery" class="query_form" size="small">
          <el-form-item label="名称">
            <el-input v-model="toolQuery.name" placeholder="名称模糊搜索" clearable
                      style="width: 140px" @keyup.enter.native="onToolSearch" />
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="toolQuery.type" placeholder="全部" clearable style="width: 92px">
              <el-option label="HTTP" value="http" />
              <el-option label="MCP" value="mcp" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="toolQuery.enabled" placeholder="全部" clearable style="width: 92px">
              <el-option label="启用" :value="true" />
              <el-option label="停用" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onToolSearch">查询</el-button>
            <el-button @click="resetToolQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <el-button v-if="canWrite" type="primary" icon="el-icon-plus" size="small" @click="openToolAdd">新增工具</el-button>
      </div>

      <!-- MCP 服务查询 -->
      <div v-show="subTab === 'mcp'" class="head_tools">
        <el-form :inline="true" :model="mcpQuery" class="query_form" size="small">
          <el-form-item label="名称">
            <el-input v-model="mcpQuery.name" placeholder="名称模糊搜索" clearable
                      style="width: 140px" @keyup.enter.native="onMcpSearch" />
          </el-form-item>
          <el-form-item label="传输">
            <el-select v-model="mcpQuery.transport" placeholder="全部" clearable style="width: 130px">
              <el-option label="streamable_http" value="streamable_http" />
              <el-option label="sse" value="sse" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onMcpSearch">查询</el-button>
            <el-button @click="resetMcpQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <el-button v-if="canWrite" type="primary" icon="el-icon-plus" size="small" @click="openMcpAdd">新增 MCP 服务</el-button>
      </div>

      <!-- 平台目录筛选 -->
      <div v-show="subTab === 'catalog'" class="head_tools">
        <el-form :inline="true" class="query_form" size="small">
          <el-form-item label="数字员工">
            <el-select v-model="catalogAgentId" placeholder="选择后查看绑定标记" clearable filterable
                       style="width: 200px" @change="loadCatalog">
              <el-option v-for="a in agentOptions" :key="a.agent_id" :label="a.display_name || a.name" :value="a.agent_id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="loadCatalog">刷新</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 子 Tab：自建工具（管理员视角即平台工具管理） -->
    <div v-show="subTab === 'tools'">
      <el-table :data="toolData" v-loading="toolLoading" border>
        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="说明" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.description || '-' }}</template>
        </el-table-column>
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'http' ? '' : 'warning'" size="small">
              {{ scope.row.type === 'http' ? 'HTTP' : 'MCP' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="small">{{ scope.row.enabled ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="timeout_sec" label="超时(秒)" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.timeout_sec || 30 }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canWrite" type="text" size="small" @click="openToolEdit(scope.row)">编辑</el-button>
            <el-button v-if="canWrite" type="text" size="small" @click="openToolTest(scope.row)">联调</el-button>
            <!-- bindings/* 与 agents/list 对管理员被 GetOwnerOrReject 拒绝（无 owner），入口必失效故隐藏 -->
            <el-button v-if="canWrite && !isAdmin" type="text" size="small" @click="openBindings(scope.row)">绑定</el-button>
            <el-button v-if="canWrite" type="text" size="small" class="danger_text" @click="handleToolDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="toolSizeChange"
        @current-change="toolPageChange"
        :current-page="toolPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="toolLimit"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="toolTotal"
      />
    </div>

    <!-- 子 Tab：MCP 服务器 -->
    <div v-show="subTab === 'mcp'">
      <el-table :data="mcpData" v-loading="mcpLoading" border>
        <el-table-column prop="name" label="名称" min-width="130" show-overflow-tooltip />
        <el-table-column prop="transport" label="传输" width="140" />
        <el-table-column prop="endpoint" label="端点" min-width="220" show-overflow-tooltip />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 'active' ? '可用' : '不可达' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最近错误" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.last_error || '-' }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="170" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canWrite" type="text" size="small" @click="openMcpEdit(scope.row)">编辑</el-button>
            <el-button v-if="canWrite" type="text" size="small" :loading="mcpTestingIds.includes(scope.row.server_id)" @click="handleMcpTest(scope.row)">测试</el-button>
            <el-button v-if="canWrite" type="text" size="small" class="danger_text" @click="handleMcpDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="mcpSizeChange"
        @current-change="mcpPageChange"
        :current-page="mcpPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="mcpLimit"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="mcpTotal"
      />
    </div>

    <!-- 子 Tab：平台目录（登录账号只读浏览 + 绑定；管理员视角隐藏） -->
    <div v-show="subTab === 'catalog'">
      <el-table :data="catalogData" v-loading="catalogLoading" border>
        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="说明" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.description || '-' }}</template>
        </el-table-column>
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'http' ? '' : 'warning'" size="small">
              {{ scope.row.type === 'http' ? 'HTTP' : 'MCP' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bill_amount" label="计费倍数" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.bill_amount || 0 }}</template>
        </el-table-column>
        <el-table-column label="已绑定" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.bound ? 'success' : 'info'" size="small">{{ scope.row.bound ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <!-- 目录绑定对个人/企业均开放（绑定的是自己的 agent），仅管理员视角隐藏（无自己的 agent） -->
        <el-table-column v-if="!isAdmin" label="操作" width="110" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.bound" type="text" size="small" class="danger_text" @click="unbindCatalog(scope.row)">解绑</el-button>
            <el-button v-else type="text" size="small" @click="bindCatalog(scope.row)">绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="catalog_tip">平台公共工具由平台统一维护，绑定后数字员工即可直接调用（复用平台配置，不复制密钥）</div>
    </div>

    <!-- 弹窗：工具新增/编辑 -->
    <tool-edit :visible.sync="editVisible" :scope="isAdmin ? 'platform' : 'self'" :urls="urls"
               :tool-id="editToolId" @saved="onToolSaved" />

    <!-- 弹窗：工具联调 -->
    <tool-test :visible.sync="testVisible" :scope="isAdmin ? 'platform' : 'self'" :urls="urls" :tool="testTool" />

    <!-- 弹窗：MCP 服务器新增/编辑 -->
    <mcp-edit :visible.sync="mcpEditVisible" :scope="isAdmin ? 'platform' : 'self'" :urls="urls"
              :server-id="mcpEditId" @saved="onMcpSaved" />

    <!-- 弹窗：工具绑定管理 -->
    <bindings :visible.sync="bindVisible" :urls="urls" :tool-id="bindToolId" :tool-name="bindToolName" />

    <!-- 弹窗：MCP 测试结果（远端工具列表） -->
    <el-dialog title="MCP 服务器连通测试" :visible.sync="mcpTestVisible"
               width="720px" v-dialogDrag :modal-append-to-body="false" v-if="mcpTestVisible"
               @closed="loadMcp(false)">
      <el-table :data="mcpTestResult" border size="small">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <pre class="stream_pre">{{ fmtSchema(scope.row.input_schema) }}</pre>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="工具名" min-width="140" show-overflow-tooltip />
        <el-table-column label="说明" min-width="260" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.description || '-' }}</template>
        </el-table-column>
        <el-table-column label="参数 Schema" width="100" align="center">
          <template slot-scope="scope">展开查看</template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="mcpTestVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isAdminAcc, canWriteTools } from '../utils'
import ToolEdit from './toolEdit.vue'
import ToolTest from './toolTest.vue'
import McpEdit from './mcpEdit.vue'
import Bindings from './bindings.vue'

// 工具/MCP/绑定/平台目录管理：企业(2)完整功能，个人(1)只读浏览+目录绑定，管理员(3)同页管理平台资源
export default {
  name: 'AiAgentTools',
  components: { ToolEdit, ToolTest, McpEdit, Bindings },
  data() {
    return {
      subTab: 'tools',
      isAdmin: isAdminAcc(),
      canWrite: canWriteTools(),
      // 自建工具列表
      toolQuery: { name: '', type: '', enabled: '' },
      toolData: [],
      toolLoading: false,
      toolPage: 1,
      toolLimit: 20,
      toolTotal: 0,
      toolReqSeq: 0,
      // MCP 列表
      mcpQuery: { name: '', transport: '' },
      mcpData: [],
      mcpLoading: false,
      mcpPage: 1,
      mcpLimit: 20,
      mcpTotal: 0,
      mcpReqSeq: 0,
      mcpTestingIds: [], // 数组记录：并发测试多台服务器时互不干扰按钮 loading
      // 平台目录
      catalogAgentId: '',
      catalogData: [],
      catalogLoading: false,
      catalogReqSeq: 0,
      agentOptions: [],
      // 弹窗状态
      editVisible: false,
      editToolId: null,
      testVisible: false,
      testTool: null,
      mcpEditVisible: false,
      mcpEditId: null,
      bindVisible: false,
      bindToolId: '',
      bindToolName: '',
      mcpTestVisible: false,
      mcpTestResult: [],
      // 懒加载标志：仅在对应列表成功返回后置位，失败可切回自动重试
      loadedTabs: { tools: false, mcp: false, catalog: false }
    }
  },
  computed: {
    // 接口前缀集中切换：管理员走 platform-*（自建即平台资源），其余走自建版；一次性算好下发弹窗
    urls() {
      const m = {
        toolsList: 'aiAgentToolsList', toolsAdd: 'aiAgentToolsAdd', toolsGet: 'aiAgentToolsGet',
        toolsEdit: 'aiAgentToolsEdit', toolsDel: 'aiAgentToolsDel', toolsTest: 'aiAgentToolsTest',
        mcpList: 'aiAgentMcpList', mcpAdd: 'aiAgentMcpAdd', mcpGet: 'aiAgentMcpGet',
        mcpEdit: 'aiAgentMcpEdit', mcpDel: 'aiAgentMcpDel', mcpTest: 'aiAgentMcpTest',
        bindList: 'aiAgentToolBindingsList', bindSet: 'aiAgentToolBindingsSet', bindDel: 'aiAgentToolBindingsDel',
        catalog: 'aiAgentPlatformCatalog', agentsList: 'aiAgentAgentsList'
      }
      if (this.isAdmin) {
        Object.assign(m, {
          toolsList: 'aiAgentPlatformToolsList', toolsAdd: 'aiAgentPlatformToolsAdd',
          toolsGet: 'aiAgentPlatformToolsGet', toolsEdit: 'aiAgentPlatformToolsEdit',
          toolsDel: 'aiAgentPlatformToolsDel', toolsTest: 'aiAgentPlatformToolsTest',
          mcpList: 'aiAgentPlatformMcpList', mcpAdd: 'aiAgentPlatformMcpAdd',
          mcpGet: 'aiAgentPlatformMcpGet', mcpEdit: 'aiAgentPlatformMcpEdit',
          mcpDel: 'aiAgentPlatformMcpDel', mcpTest: 'aiAgentPlatformMcpTest'
        })
      }
      const out = {}
      Object.keys(m).forEach(k => { out[k] = this.$baseUrl[m[k]] })
      return out
    }
  },
  methods: {
    onActivate() {
      this.loadCurrentTab()
    },
    loadCurrentTab() {
      const key = this.subTab
      if (this.loadedTabs[key]) return
      if (key === 'tools') this.loadTools()
      else if (key === 'mcp') this.loadMcp()
      else if (key === 'catalog') { this.loadAgentOptions(); this.loadCatalog() }
    },
    // ---------- 自建工具 ----------
    loadTools() {
      this.toolLoading = true
      const data = { page: this.toolPage, limit: this.toolLimit }
      if (this.toolQuery.name) data.name = this.toolQuery.name
      if (this.toolQuery.type) data.type = this.toolQuery.type
      if (this.toolQuery.enabled !== '' && this.toolQuery.enabled !== null) data.enabled = this.toolQuery.enabled
      const seq = ++this.toolReqSeq
      this.$tools.asyncPost(this, this.urls.toolsList, agentBody(data)).then((res) => {
        if (seq !== this.toolReqSeq) return
        if (res.data.code == 0) {
          this.toolData = res.data.data.data || []
          this.toolTotal = res.data.data.total || 0
          this.loadedTabs.tools = true // 成功才记缓存，失败切回子 Tab 自动重试
        }
        this.toolLoading = false
      }).catch(() => {
        if (seq === this.toolReqSeq) this.toolLoading = false
        this.loadedTabs.tools = false
      })
    },
    onToolSearch() { this.toolPage = 1; this.loadTools() },
    resetToolQuery() { this.toolQuery = { name: '', type: '', enabled: '' }; this.onToolSearch() },
    toolSizeChange(v) { this.toolLimit = v; this.loadTools() },
    toolPageChange(v) { this.toolPage = v; this.loadTools() },
    openToolAdd() { this.editToolId = null; this.editVisible = true },
    // edit 全量覆盖：由子组件先 get 回填完整对象再整体提交
    openToolEdit(row) { this.editToolId = row.tool_id; this.editVisible = true },
    openToolTest(row) { this.testTool = row; this.testVisible = true },
    openBindings(row) { this.bindToolId = row.tool_id; this.bindToolName = row.name; this.bindVisible = true },
    onToolSaved() { this.loadTools() },
    handleToolDel(row) {
      this.$MessageBox.confirm('删除后不可恢复，确认删除工具「' + row.name + '」？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.urls.toolsDel,
          agentBody({ tool_id: row.tool_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.toolData.length === 1 && this.toolPage > 1) this.toolPage -= 1
            this.loadTools()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    // ---------- MCP ----------
    loadMcp(loading = true) {
      if (loading) this.mcpLoading = true
      const data = { page: this.mcpPage, limit: this.mcpLimit }
      if (this.mcpQuery.name) data.name = this.mcpQuery.name
      if (this.mcpQuery.transport) data.transport = this.mcpQuery.transport
      const seq = ++this.mcpReqSeq
      this.$tools.asyncPost(this, this.urls.mcpList, agentBody(data)).then((res) => {
        if (seq !== this.mcpReqSeq) return
        if (res.data.code == 0) {
          this.mcpData = res.data.data.data || []
          this.mcpTotal = res.data.data.total || 0
          this.loadedTabs.mcp = true
        }
        this.mcpLoading = false
      }).catch(() => {
        if (seq === this.mcpReqSeq) this.mcpLoading = false
        this.loadedTabs.mcp = false
      })
    },
    onMcpSearch() { this.mcpPage = 1; this.loadMcp() },
    resetMcpQuery() { this.mcpQuery = { name: '', transport: '' }; this.onMcpSearch() },
    mcpSizeChange(v) { this.mcpLimit = v; this.loadMcp() },
    mcpPageChange(v) { this.mcpPage = v; this.loadMcp() },
    openMcpAdd() { this.mcpEditId = null; this.mcpEditVisible = true },
    openMcpEdit(row) { this.mcpEditId = row.server_id; this.mcpEditVisible = true },
    onMcpSaved() { this.loadMcp() },
    // 测试连通：成功弹远端工具列表；失败拦截器已弹错，列表刷新可见 unreachable/last_error（后端回写）
    handleMcpTest(row) {
      this.mcpTestingIds.push(row.server_id)
      const done = () => { this.mcpTestingIds = this.mcpTestingIds.filter(id => id !== row.server_id) }
      this.$tools.asyncPost(this, this.urls.mcpTest,
        agentBody({ server_id: row.server_id })).then((res) => {
        done()
        if (res.data.code == 0) {
          this.mcpTestResult = (res.data.data && res.data.data.tools) || []
          this.mcpTestVisible = true
          if (!this.mcpTestResult.length) this.$message({ type: 'warning', message: '该服务器未返回工具列表' })
        }
        this.loadMcp(false) // status 被回写为 active，静默刷新
      }).catch((err) => {
        done()
        this.loadMcp(false) // status 被回写为 unreachable，静默刷新
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '测试请求失败，请稍后重试' })
      })
    },
    // del 被工具引用时后端拒绝，拦截器已弹 msg，属正常业务提示
    handleMcpDel(row) {
      this.$MessageBox.confirm('删除后不可恢复，确认删除 MCP 服务「' + row.name + '」？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.urls.mcpDel,
          agentBody({ server_id: row.server_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.mcpData.length === 1 && this.mcpPage > 1) this.mcpPage -= 1
            this.loadMcp()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    fmtSchema(s) {
      if (!s) return '（无参数 schema）'
      try { return JSON.stringify(JSON.parse(s), null, 2) } catch (e) { return s }
    },
    // ---------- 平台目录 ----------
    loadAgentOptions() {
      this.$tools.asyncPost(this, this.urls.agentsList, agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) this.agentOptions = res.data.data.data || []
      }).catch(() => { this.loadedTabs.catalog = false }) // 下拉失败则目录缓存失效，切回可重试
    },
    loadCatalog() {
      this.catalogLoading = true
      const data = {}
      if (this.catalogAgentId) data.agent_id = this.catalogAgentId // 传入才带 bound 标记
      const seq = ++this.catalogReqSeq
      this.$tools.asyncPost(this, this.urls.catalog, agentBody(data)).then((res) => {
        if (seq !== this.catalogReqSeq) return
        if (res.data.code == 0) {
          this.catalogData = res.data.data.data || []
          this.loadedTabs.catalog = true
        }
        this.catalogLoading = false
      }).catch(() => {
        if (seq === this.catalogReqSeq) this.catalogLoading = false
        this.loadedTabs.catalog = false
      })
    },
    bindCatalog(row) {
      if (!this.catalogAgentId) {
        return this.$message({ type: 'warning', message: '请先选择数字员工再绑定' })
      }
      this.$tools.asyncPost(this, this.urls.bindSet,
        agentBody({ agent_id: this.catalogAgentId, tool_id: row.tool_id, enabled: true })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '绑定成功' })
          this.loadCatalog()
        }
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
      })
    },
    unbindCatalog(row) {
      this.$MessageBox.confirm('确认解绑「' + row.name + '」？解绑后该数字员工不可再调用此工具', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.urls.bindDel,
          agentBody({ agent_id: this.catalogAgentId, tool_id: row.tool_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已解绑' })
            this.loadCatalog()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  },
  watch: {
    subTab() { this.loadCurrentTab() }
  },
  mounted() {
    this.onActivate()
  }
}
</script>

<style lang="less" scoped>
.page_head {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  // 白色卡片容器：子 Tab 行 + 查询行，与页面级 Tab 视觉一致
  padding: 0;
  margin-bottom: 12px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.sub_tabs {
  display: flex;
  gap: 32px;
  padding: 0 12px;
  border-bottom: 1px solid #e9eaec;
  span {
    position: relative;
    padding: 10px 0;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    &.active {
      color: #303133;
      font-weight: 600;
      // 选中态底部蓝色下划线（与订单页 Tab 同款）
      &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 3px;
        background: #409eff;
      }
    }
  }
}
.head_tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  .query_form {
    /deep/ .el-form-item {
      margin: 0 10px 0 0;
    }
    /deep/ .el-form-item:last-child {
      margin-right: 0;
    }
    /deep/ .el-form-item__label {
      line-height: 32px;
    }
  }
}
.danger_text { color: #f56c6c; }
.catalog_tip { color: #909399; font-size: 12px; margin-top: 8px; }
.stream_pre {
  max-height: 240px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 8px;
  font-size: 12px;
  margin: 0;
}
</style>
